import React from "react";
import Modal, { Props, Styles } from "react-modal";

export const customStyles: Styles = {
    overlay: {
        position: "fixed",
        zIndex: 100,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
    },
    content: {
        position: "static",
        display: "flex",
        flexDirection: "row",
        gap: "10px",
        width: "auto",
        padding: 0,
        boxShadow: "0px 0px 5px rgba(49, 69, 49, 0.14)",
        borderRadius: "10px",
    },
};

type AdditionalProps = {
    workspaceId?: number;
    contentElement?: any;
    title?: string;
    description?: string;
    onApplyClick?: any;
    areYouSureApplyAction?: any;
    onChoose?: any;
    value?: string
};

const BasedModal = ({
    isOpen,
    style,
    onRequestClose,
    children,
    contentElement,
}: IProps) => {
    return (
        <Modal
            style={style || customStyles}
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            contentElement={contentElement}
            appElement={document.getElementById("root")!}
        >
            {children}
        </Modal>
    );
};

export type IProps = Props & Styles & AdditionalProps;

export default BasedModal;
